import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { VoidLeaseAgreementComponent } from '../void-lease-agreement/void-lease-agreement.component';
import { CooperativeHousingContractService } from '../../service/data/cooperative-housing-contract.service';
import { LeaseAgreementService } from '../../service/data/lease-agreement.service';

@Component({
    selector: 'app-void-cooperative-housing-lease-agreement',
    templateUrl: '../void-cooperative-housing-lease-agreement/void-cooperative-housing-lease-agreement.component.html',
    styleUrls: ['../void-cooperative-housing-lease-agreement/void-cooperative-housing-lease-agreement.component.scss'],
    providers: [NavigationService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VoidCooperativeHousingLeaseAgreementComponent extends VoidLeaseAgreementComponent { 
}
